/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    // Consent Detail
    getConstentDetail(consentId) {
        return HttpService.get(
            environment.API_CONSENT + `/detail/${consentId}`
        );
    },
    getActivity(params) {
        return HttpService.get(environment.API_CONSENT + '/activity-related', {
            params,
        });
    },
    getDataSubject(params) {
        return HttpService.get(
            environment.API_CONSENT + '/datasubject-related',
            {
                params,
            }
        );
    },
    // Application
    getApplicationRelated() {
        return HttpService.get(
            environment.API_CONSENT + `/application-related`
        );
    },
    addApplication(payload) {
        return HttpService.post(
            environment.API_CONSENT + '/application',
            payload
        );
    },
    editApplication(payload) {
        return HttpService.put(
            environment.API_CONSENT + '/application',
            payload
        );
    },
    deleteApplication(consentId, applicationId) {
        return HttpService.delete(
            environment.API_CONSENT +
                `/${consentId}/application/${applicationId}`
        );
    },
    // Consent
    searchConsentList(params) {
        return HttpService.get(environment.API_CONSENT, {
            params: params,
        });
    },
    addConsent(payload) {
        return HttpService.post(environment.API_CONSENT, payload);
    },
    editConsent(payload) {
        return HttpService.put(environment.API_CONSENT, payload);
    },
    deleteConsent(consentId) {
        return HttpService.delete(environment.API_CONSENT + `/${consentId}`);
    },
    exportConsentLog(params) {
        return HttpService.get(environment.API_CONSENT_LOG + '/export', {
            params,
        });
    },
    exportConsent(params) {
        return HttpService.post(
            environment.API_CONSENT + '/export',
            {
                ...params,
            },
            {
                responseType: 'blob',
            }
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(environment.API_CONSENT + `/history`, {
            params,
        });
    },

    getHistoryDetail(params) {
        return HttpService.get(environment.API_CONSENT + `/history/detail`, {
            params,
        });
    },

    // Dashboard
    getConsentGraph(params) {
        return HttpService.get(environment.API_CONSENT + '/graph', {
            params,
        });
    },
    getConsentSearch(params) {
        return HttpService.get(environment.API_CONSENT + '/search', {
            params,
        });
    },

    // Manage Consent
    getConsentCountIdentity(params) {
        return HttpService.get(environment.API_WFSECURE + '/count/identity', {
            params,
        });
    },
    searchManageConsent(params) {
        return HttpService.get(
            environment.API_WFSECURE + '/manage-consent/search',
            {
                params,
            }
        );
    },
    getDetailConsent(params) {
        return HttpService.get(environment.API_MANAGE_CONSENT + `/detail`, {
            params,
        });
    },
    reconsent(payload) {
        return HttpService.put(
            environment.API_WFSECURE + '/manage-consent',
            payload
        );
    },
    getVersion(id) {
        return HttpService.get(
            environment.API_WFSECURE + '/manage-consent/version/' + id
        );
    },
};
